/** Thresholds mirrored from modelAPI version download CSV gating defaults. */
export const CSV_EXPORT_MAX_ROWS = 100_000;
export const CSV_EXPORT_MAX_BYTES = 50 * 1024 * 1024;

export type DataSourceVersionDownloadMeta = {
  row_count?: number | null;
  file_size_bytes?: number | null;
  storage_format?: string | null;
};

export const getOriginalDownloadExtension = (storageFormat?: string | null): string => {
  if (storageFormat === 'parquet') {
    return 'parquet';
  }
  return 'csv';
};

export const getCsvExportBlockReason = (version: DataSourceVersionDownloadMeta): string | null => {
  const rowCount = version.row_count ?? null;
  const fileSizeBytes = version.file_size_bytes ?? null;

  if (rowCount != null && rowCount > CSV_EXPORT_MAX_ROWS) {
    return `CSV export is unavailable above ${CSV_EXPORT_MAX_ROWS.toLocaleString()} rows (this version has ${rowCount.toLocaleString()}). Download the original file instead.`;
  }
  if (fileSizeBytes != null && fileSizeBytes > CSV_EXPORT_MAX_BYTES) {
    const fileSizeMb = Math.max(1, Math.round(fileSizeBytes / (1024 * 1024)));
    const limitMb = CSV_EXPORT_MAX_BYTES / (1024 * 1024);
    return `CSV export is unavailable above ${limitMb}MB (this version is ${fileSizeMb}MB). Download the original file instead.`;
  }
  return null;
};
